'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlotBarIcon = function PlotBarIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 32 32' }, props),
        _react2.default.createElement('path', { d: 'M0 21.313h10.688v5.375H0zm0-7.938h21.375v5.313H0zm0-8.062h32v5.375H0z' })
    );
};

exports.default = PlotBarIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/plotly-icons/lib/components/PlotBarIcon.js
// module id = 647
// module chunks = 0